import { useNavigate } from "react-router-dom";
import { useState, useContext } from "react";
import { GlobalContext } from "../../context/Provider";
import henceforthApi from "../../utils/henceforthApi";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

function ChangePassword() {
  const navigate = useNavigate();
  const [state, setState] = useState({
    oldPass: "",
    newPass: "",
    confirmPass: "",
    language: "ENGLISH",
  });

  const { authState, authDispatch } = useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);

  const handleChange = (e) => {
    console.log(e);
    const name = e.target.name;
    const value = e.target.value;

    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      state.newPass !== state.confirmPass
    ) {
      // toast("Password not same")
      Swal.fire({
        title: "Error!",
        text: "New password & confirm Password not same",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "black"

      })
      return
    }
    if (state.oldPass === state.newPass) {
      // toast("")
      Swal.fire({
        title: "Error!",
        text: "Old password & new password should not be same",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "black"

      })
      return
    }
    if (state.newPass !== state.confirmPass) {
      // toast("")
      Swal.fire({
        title: "Error!",
        text: "New password & confirm password should be same",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "black"

      })
      return
    }
    if (state.newPass.length <= 5) {
      // toast("")
      Swal.fire({
        title: "Error!",
        text: "Password length should be more than or equal to 6 character",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "black"

      })
      return
    }

    henceforthApi.Administrator.changePassword(state)
      .then((res) => {
        console.log(res, "resposne changepassd");
        Swal.fire({
          title: "Changed Password",
          text: "Password Changed  successfully",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "black"

        }).then((isConfirm) => {
          if (isConfirm) {
            navigate("/");
          }
        });
      })
      .catch((err) => {
        console.log(err, "error");
        Swal.fire({
          title: "Error!",
          text: err.response.body.error_description,
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "black"

        });
      });

  };

  const [firstEye, setFirstEye] = useState(true);
  const [firstEye2, setFirstEye2] = useState(true);
  const [firstEye3, setFirstEye3] = useState(true);

  return (
    <div class="animated fadeInDown">
      <div class="row">
        <div class="col-md-5 loginscreen">
          <div class="ibox-content mb-4">
            <div class="row">
              <div class="col-lg-12">
                <form onSubmit={handleSubmit} class="m-t" role="form">
                  <div class="form-group">
                    <input
                      onChange={handleChange}
                      type={firstEye ? "password" : "text"}
                      class="form-control"
                      placeholder="Enter old password"
                      name="oldPass"
                      value={state.oldPass}
                      required
                    />
                    <i
                      class={`fas  eye-btn ${firstEye ? `fa-eye-slash` : `fa-eye`
                        }`}
                      onClick={() => setFirstEye(!firstEye)}
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </div>
                  <div class="form-group">
                    <input
                      name="newPass"
                      onChange={handleChange}
                      value={state.newPass}
                      type={firstEye2 ? "password" : "text"}
                      class="form-control"
                      placeholder="Enter new password"
                      required
                    />
                    <i
                      class={`fas  eye-btn ${firstEye2 ? `fa-eye-slash` : `fa-eye`
                        }`}
                      onClick={() => setFirstEye2(!firstEye2)}
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}

                    ></i>
                  </div>

                  <div class="form-group">
                    <input
                      name="confirmPass"
                      onChange={handleChange}
                      value={state.confirmPass}
                      type={firstEye3 ? "password" : "text"}
                      class="form-control"
                      placeholder="Enter confirm password"
                      required
                    />
                    <i
                      class={`fas  eye-btn ${firstEye3 ? `fa-eye-slash` : `fa-eye`
                        }`}
                      onClick={() => setFirstEye3(!firstEye3)}
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}

                    ></i>
                  </div>

                  <div className="form-group">
                    {/* <button onClick={() => navigate('/profile')} type="button" class="btn btn-white me-2">
                      Cancel
                    </button> */}
                    <button type="submit" class="btn btn-primary me-2">
                      Change Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
